"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runAllRulesets = exports.runRulesets = void 0;
const functional_1 = require("../utils/functional");
const rulesets_1 = require("../handlers/rulesets");
// =======
// ACTIONS
// =======
const constants_1 = require("../constants");
// ===============
// ACTION CREATORS
// ===============
const runRulesets = ({ formId, formIndex, rulesets: localRulesets }) => async (dispatch, getState) => {
    if (localRulesets && localRulesets.length) {
        const { rex } = getState();
        const { config, version } = rex;
        if (version[formId] > 1) {
            dispatch({
                type: constants_1.UPDATE_RULESET_RESULTS,
                responses: await (0, rulesets_1.executeFormsV2Rulesets)({
                    localRulesets,
                    rulesets: rex.formsv2[formId].rulesets,
                    config,
                    model: rex.formModel[formId],
                }),
                formId,
            });
            return;
        }
        const { rulesets = {} } = rex.forms[formId][formIndex];
        const models = rex.models[formId];
        const results = await (0, functional_1.pipe)(models)((0, rulesets_1.executeRulesets)({
            localRulesets,
            rulesets,
            config,
        }));
        dispatch({
            type: constants_1.UPDATE_RULESET_RESULTS,
            responses: results,
            formId,
        });
    }
};
exports.runRulesets = runRulesets;
const runAllRulesets = (formId) => async (dispatch, getState) => {
    const { rex } = getState();
    if (rex.version[formId] > 1) {
        return;
    }
    const { config, forms, version } = rex;
    if (version[formId] > 1) {
        const { rulesets } = rex.formsv2[formId];
        dispatch({
            type: constants_1.UPDATE_RULESET_RESULTS,
            responses: await (0, rulesets_1.executeFormsV2Rulesets)({
                localRulesets: Object.keys(rulesets),
                rulesets: rex.formsv2[formId].rulesets,
                config,
                model: rex.formModel[formId],
            }),
            formId,
        });
        return;
    }
    const models = rex.models[formId];
    const allRulesets = (0, functional_1.pipe)(forms[formId])((0, functional_1.map)((form) => form.rulesets), functional_1.mergeObjects);
    const results = await (0, functional_1.pipe)(models)((0, rulesets_1.executeRulesets)({
        localRulesets: Object.keys(allRulesets),
        rulesets: allRulesets,
        config,
    }));
    dispatch({
        type: constants_1.UPDATE_RULESET_RESULTS,
        responses: results,
        formId,
    });
};
exports.runAllRulesets = runAllRulesets;
// =======
// REDUCER
// =======
const rulesetArrToObj = (rulesets) => rulesets.reduce((acc, { rulesetId, ...rest }) => ({
    ...acc,
    [rulesetId]: { rulesetId, ...rest },
}), {});
const rulesetReducer = (state = {}, { type, ...action }) => {
    switch (type) {
        case constants_1.LOAD_NEW_FORMS: {
            return Array.isArray(state[action.id])
                ? state
                : { ...state, [action.id]: [] };
        }
        case 'FormModel/LOAD_FORM': {
            return Array.isArray(state[action.payload.modelKey])
                ? state
                : { ...state, [action.payload.modelKey]: [] };
        }
        case constants_1.UPDATE_RULESET_RESULTS: {
            const { responses, formId } = action;
            const oldRulesets = state[formId];
            const oldRulesetsMap = rulesetArrToObj(oldRulesets);
            const newRulesetsMap = rulesetArrToObj(responses);
            const finalRulesetState = functional_1.pipe.objToArr({
                ...oldRulesetsMap,
                ...newRulesetsMap,
            })((0, functional_1.filter)(([, v]) => v.result === 'YES'), (0, functional_1.map)(([, v]) => v));
            return {
                ...state,
                [formId]: finalRulesetState,
            };
        }
        case constants_1.REMOVE_FORM: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [action.id]: remove, ...newState } = state;
            return newState;
        }
        default:
            return state;
    }
};
exports.default = rulesetReducer;
//# sourceMappingURL=rulesets.js.map